import { Box } from '@primer/react';
import Steps from '../../../components/steps';
import { IStepData } from '../../../components/steps/Steps';
interface IBaoPhiStepsProps {
    steps: IStepData[],
    currentStepId: number,
    onStepChanged: (id: number) => void
}
const BaoPhiSteps = (props: IBaoPhiStepsProps) => {
    return (
        <Box>
            <Steps
                steps={props.steps.map(x=>{
                    return {
                        ...x,
                        is_active: x.id=== props.currentStepId
                    }
                })}
                onChangedStep={props.onStepChanged}
            />
        </Box>
    );
};

export default BaoPhiSteps;